import { uid } from "@xbs/lib-state";
export function uncheckSelectedTasks({ store }) {
    const selected = store.getState().selected;
    let $meta;
    if (selected.length > 1) {
        $meta = { batch: uid() };
    }
    store.eachSelected(id => {
        if (store.getTask(id)?.checked) {
            store.in.exec("uncheck-task", { id, $meta });
        }
    }, true);
}
//# sourceMappingURL=uncheck.js.map